export default {
    getFormActions: state => state.formActions,
    getFormFields: state => state.formFields
}